var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createTheme } from '@mui/material';
import isArray from 'lodash/isArray';
import mergeWith from 'lodash/mergeWith';
import celesTheme from './celes';
import colors from './colors';
import legacyTheme from './legacy';
import textDefinitions, { fontFamily } from './textDefinitions';
// needed as deepmerge does not support merging arrays
var customizer = function (objValue, srcValue) {
    if (isArray(objValue)) {
        return [].concat.apply([], __spreadArray(__spreadArray([], objValue, false), [srcValue], false));
    }
    return undefined;
};
var mainTheme = createTheme(__assign({}, mergeWith(legacyTheme, celesTheme, {
    palette: {
        primary: {
            main: colors.bigBangBlack
        },
        secondary: {
            main: colors.neutral5
        },
        info: {
            main: colors.blue70
        },
        success: {
            main: colors.green60
        },
        warning: {
            main: colors.yellow30
        },
        error: {
            main: colors.red60
        }
    },
    typography: __assign({ fontFamily: fontFamily, allVariants: {
            color: colors.neutral100,
            WebkitTextSizeAdjust: '100%',
            MsTextSizeAdjust: '100%',
            WebkitFontSmoothing: 'antialiased',
            MozOsxFontSmoothing: 'grayscale',
            WebkitTapHighlightColor: 'transparent'
        }, h2: {
            fontSize: '48px',
            lineHeight: '64px',
            fontWeight: 600,
            letterSpacing: '-0.5px',
            fontFamily: "termina, ".concat(fontFamily)
        }, h4: {
            fontSize: '24px',
            lineHeight: '32px',
            fontWeight: 'bold',
            fontFamily: "termina, ".concat(fontFamily)
        }, h5: {
            fontSize: '20px',
            lineHeight: '28px',
            fontWeight: 800,
            fontFamily: "termina, ".concat(fontFamily)
        }, h6: {
            fontSize: '18px',
            fontWeight: 800,
            lineHeight: '24px',
            fontFamily: "termina, ".concat(fontFamily),
            letterSpacing: '0.15px'
        }, overline: {
            fontWeight: 700,
            fontSize: '12px',
            lineHeight: '16px',
            color: colors.legacy.slateLight,
            letterSpacing: '0.01em'
        }, subtitle1: {
            fontWeight: 'bold',
            fontSize: '16px',
            lineHeight: '24px'
        }, subtitle2: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 'bold'
        }, p1: {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 500
        }, p2: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 500
        }, button1: {
            fontSize: '16px',
            lineHeight: '24px',
            fontWeight: 'bold'
        }, button2: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 'bold'
        }, body1: {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: '600'
        }, body2: {
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: 500
        }, body3: {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 400
        }, table: {
            fontSize: '14px',
            lineHeight: '16px',
            fontWeight: 'normal'
        }, tableHead: {
            fontSize: '14px',
            lineHeight: '16px',
            fontWeight: 'bold'
        }, tableColumnHead: {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '16px',
            letterSpacing: '-2%'
        }, table1: {
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '20px',
            letterSpacing: '-2%'
        }, table2: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '-2%'
        }, table3: {
            fontSize: '12px',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '-2%'
        }, caption: {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 500
        } }, textDefinitions),
    shape: {
        borderRadius: 4
    }
}, customizer)));
export default mainTheme;
